module.exports = __webpack_public_path__ + "static/EPD-lamppost_mobile_simp_Chi_banner_low-f59767e41a55a5b1fe8144a42383372c.png";